import AlbumFolderStartShutterbug from './AlbumFolderStartShutterbug';

export default AlbumFolderStartShutterbug;
